import { type FC, type PropsWithChildren } from 'react'

import { type LoginAfterLoggedIn } from '../../loginAfterLoggedIn'

import { LoginRegistrationLoginRenderSwitch } from './LoginRegistrationUserLoginRenderSwitch'

interface LoginRegistrationUserLoginContentProps {
  afterLoggedIn: LoginAfterLoggedIn
}

export const LoginRegistrationUserLoginContent: FC<
  PropsWithChildren<LoginRegistrationUserLoginContentProps>
> = ({ afterLoggedIn, children }) => {
  return (
    <LoginRegistrationLoginRenderSwitch afterLoggedIn={afterLoggedIn}>
      {children}
    </LoginRegistrationLoginRenderSwitch>
  )
}
